import React from "react";
import "./About.css";
import moises from "../../images/moises-about.jpeg";

const About = () => {
  return (
    <section className="sobre" id="sobre">
      <div className="sobre-content">
        <h1>Sobre mim</h1>

        <div className="sobre-image">
          <img src={moises} alt="Moisés Potiguara Filho" />
        </div>

        <h2>Moisés Potiguara Filho</h2>

        <div className="sobre-text">
          <h3>
            <span className="destaque">Advogado,</span> inscrito na OAB/PA n°
            37.983, Bacharel em Direito pelo Centro Universitário do Estado do Pará
            (CESUPA) e Pós-graduado em Direito e Processo do Trabalho pela
            Pontifícia Universidade Católica do Rio Grande do Sul (PUC-RS).
            Atua no Direito do Trabalho oferecendo soluções jurídicas eficientes
            tanto para empresas quanto para trabalhadores.
          </h3>
        </div>
      </div>

      {/* BLOCO COM FUNDO ESCURO */}
      <div className="sobre-missao">
        <div className="sobre-content">
          <h2 className="missao-title">Missão</h2>

          <div className="sobre-text">
            <h3>
              <span className="destaque-white">Atuar</span> com ética,
              honestidade e transparência em todas as etapas do atendimento
              jurídico, construindo uma relação de confiança sólida e verdadeira
              com cada cliente. Prestar orientações claras, objetivas e
              realistas, sempre pautadas na lealdade profissional, no rigor
              técnico e na comunicação aberta.
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
